import { defineMessages } from 'react-intl'

const tourRoomTypeMessages = defineMessages({
  single: {
    id: 'Fk5SDJb6KOcbRV9Gx1fS',
    defaultMessage: 'Single room',
    description: 'Tour room type label for a single occupancy room in booking',
  },
  twin: {
    id: 'GMxrYrOHrGYbPC5hXBA9',
    defaultMessage: 'Twin share room',
    description: 'Tour room type label for a twin share room in booking selection',
  },
  twinShare: {
    id: '4jksZZ-q1G18tEzqvlk7',
    defaultMessage: 'Twin share',
    description: 'Tour room type label for a shared twin room in booking selection',
  },
  triple: {
    id: '70Hv6JjDgpL9N7laZrD8',
    defaultMessage: 'Triple room',
    description: 'Tour room type label for a triple occupancy room in booking',
  },
  tripleShare: {
    id: 'GcRzpmc0j1YHfYydpwRj',
    defaultMessage: 'Triple share',
    description: 'Tour room type label for a shared triple room in booking selection',
  },
  quad: {
    id: 'LGJ_qo_toVelUaFtWljh',
    defaultMessage: 'Quad room',
    description: 'Tour room type label for a quad occupancy room in booking selection',
  },
  quadShare: {
    id: 'PK2tAcBW_awxHaKO_hdr',
    defaultMessage: 'Quad share',
    description: 'Tour room type label for a shared quad room in booking selection',
  },
  multiShare: {
    id: 'SnoKGCCq59t-_DRM7y4B',
    defaultMessage: 'Multi share',
    description: 'Tour room type label for a multi-share room in booking selection',
  },
})

export default tourRoomTypeMessages
